import React from 'react';
import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';

interface DivineOrbIconProps {
  size?: number | string;
  sx?: SxProps<Theme>;
  alt?: string;
}

const DivineOrbIcon: React.FC<DivineOrbIconProps> = ({ size = 20, sx = {}, alt = 'Divine Orb' }) => {
  return (
    <Box
      component='img'
      src='https://cdn.poedb.tw/image/Art/2DItems/Currency/CurrencyModValues.webp'
      alt={alt}
      sx={{
        width: size,
        height: size,
        objectFit: 'contain',
        display: 'inline-block',
        verticalAlign: 'middle',
        ...sx,
      }}
    />
  );
};

export default DivineOrbIcon;
